import React from "react";
import { Link } from "react-router-dom";
import styles from "../../styles/HomePage.module.css";
import { ROUTES } from "../../config/routes";

export default function FeatureCardsSection() {
    return (
        <section className={styles.features}>
            <h2 className={styles.sectionTitle}>Build These Essential Skills</h2>
            <div className={styles.featureGrid}>
                <Link to={ROUTES.DRILL.INTERVALS} className={styles.featureCard}>
                    <div className={styles.featureIcon}>
                        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                            <path
                                d="M12 24L24 12L36 24M24 12V36"
                                stroke="currentColor"
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </div>
                    <h3 className={styles.featureTitle}>Interval Recognition</h3>
                    <p className={styles.featureDescription}>
                        The foundation of playing by ear. Learn to hear the distance between any two
                        notes so you can recreate melodies you hear in your head.
                    </p>
                    <div className={styles.featureBadge}>Start Here</div>
                </Link>

                <Link to={ROUTES.DRILL.CHORDS} className={styles.featureCard}>
                    <div className={styles.featureIcon}>
                        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                            <circle cx="24" cy="12" r="3" fill="currentColor" />
                            <circle cx="16" cy="28" r="3" fill="currentColor" />
                            <circle cx="32" cy="28" r="3" fill="currentColor" />
                            <path
                                d="M24 15V25M24 25L16 28M24 25L32 28"
                                stroke="currentColor"
                                strokeWidth="2.5"
                                strokeLinecap="round"
                            />
                        </svg>
                    </div>
                    <h3 className={styles.featureTitle}>Chord Identification</h3>
                    <p className={styles.featureDescription}>
                        Know what chord is being played just by listening. Essential for figuring out
                        songs, improvising, and understanding how music works.
                    </p>
                    <div className={styles.featureBadge}>Core Skill</div>
                </Link>

                <Link to={ROUTES.DRILL.PROGRESSIONS} className={styles.featureCard}>
                    <div className={styles.featureIcon}>
                        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                            <path
                                d="M8 24H16L20 12L28 36L32 24H40"
                                stroke="currentColor"
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </div>
                    <h3 className={styles.featureTitle}>Chord Progressions</h3>
                    <p className={styles.featureDescription}>
                        Recognize the chord patterns that show up in thousands of songs. Once you know
                        these, you can play along with almost anything.
                    </p>
                    <div className={styles.featureBadge}>Advanced</div>
                </Link>
            </div>
        </section>
    );
}
